export default "__VITE_ASSET__6Q86_Es___"